import React from 'react';

import RIQModal from '../../../components/RIQModal.jsx';

import {
    useIsExporting
} from '../../../hooks/useExport.js';

import {
    useLoadLandscapeListeningQuery,
    useGetListeningQueryDisplayName
} from '../hooks/useListeningQueryPersistence.js';

export default function GeneratingQueryModal({hidden = false, isAnyWidgetLoaded, listeningQueryId}) {

    const isExporting = useIsExporting();

    const {data: listeningQuery} = useLoadLandscapeListeningQuery(listeningQueryId);
    const searchDisplayName = useGetListeningQueryDisplayName(listeningQuery, listeningQueryId);

    let listeningQueryText = null;
    if (listeningQuery) {
        listeningQueryText = (
            <div>{searchDisplayName}</div>
        );
    }

    const message = `Generating Social Listening results${listeningQuery ? ' for' : ''}`;

    const showModal = (!isExporting && !hidden && !isAnyWidgetLoaded && Boolean(listeningQueryId));

    return (
        <RIQModal
            showModal={showModal}
            variant='small'
        >
            <div className='tlw-m-15 tlw-flex tlw-min-h-[180px] tlw-flex-col tlw-place-items-center tlw-gap-10'>
                <div className='tlw-text-[36px] tlw-text-gray-500'>
                    <span className='fa fa-circle-o-notch fa-spin'></span>
                </div>

                <div className='tlw-grow tlw-text-center tlw-text-md tlw-leading-24'>
                    <div className='tlw-font-bold'>{message}</div>
                    {listeningQueryText}
                </div>
            </div>
        </RIQModal>
    );
}
